import { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoFieldModel } from '../../../';

class GeckoFieldBase extends Component {
  handleChange(event) {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(event.target.value)
    )();
  }

  handleBlur(event) {
    if (this.props.field.onBlur) return this.props.field.onBlur(event);
    return;
  }

  prepareValue(value) {
    return value;
  }

  field() {
    return this.props.field;
  }

  value() {
    // get nested object values from a key like 'nested.object.value' to target {nested: {object: {value: 'test'}}}
    const keyFragments = this.field().key.split('.');
    const getValue = (obj, key) => obj[key];
    return keyFragments.reduce(getValue, this.props.values);
  }

  renderId() {
    return `field_${this.props.field.key}`;
  }

  isDisabled() {
    return (
      this.field().disabled ||
      (this.field().disabledWhen ? this.field().disabledWhen() : false)
    );
  }
  isBeta() {
    return this.field().isBeta;
  }

  options() {
    return this.field().options && Array.isArray(this.field().options)
      ? this.field().options
      : [];
  }

  config() {
    return this.field().config || {};
  }
}

GeckoFieldBase.propTypes = {
  field: PropTypes.shape(GeckoFieldModel).isRequired,
};

export default GeckoFieldBase;
